import React from "react";
import { Box, Typography } from "@mui/material";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export type HeaderDialogVariant = "mobile" | "desktop";
export type HeaderDialogSeverity = "success" | "warning" | "error" | string;

type Props = {
  title: string;
  subtitle?: string;
  severity: HeaderDialogSeverity;
  variant?: HeaderDialogVariant;
};

const CONFIG = {
  success: {
    icon: CheckCircleOutlineIcon,
    color: "success.main",
  },
  warning: {
    icon: WarningAmberIcon,
    color: "warning.main",
  },
  error: {
    icon: ErrorOutlineIcon,
    color: "error.main",
  },
} as const;

export function HeaderDialog({
  title,
  subtitle,
  severity,
  variant = "desktop",
}: Props) {
  const isMobile = variant === "mobile";
  const { icon: Icon, color } = CONFIG[severity];

  return (
    <Box
      position="relative"
      display="flex"
      flexDirection="column"
      alignItems="center"
      textAlign="center"
      px={isMobile ? 1 : 0}
      mb={isMobile ? 2.5 : 3}
    >
      <Icon
        sx={{
          fontSize: isMobile ? 50 : 64,
          color,
          mb: 1.25,
        }}
      />

      <Typography
        variant={isMobile ? "h6" : "h5"}
        fontWeight={900}
        color={color}
        sx={{ lineHeight: 1.15 }}
      >
        {title}
      </Typography>

      {subtitle && (
        <Typography
          variant="body2"
          color="text.primary"
          sx={{
            mt: 0.75,
            maxWidth: isMobile ? "100%" : 520,
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}
